import React from 'react';
import ActionPointsBrowser from "./Views/BrowserView/ActionPoints";
import ActionListMobile from './Views/MobileView/ActionList';

export default function ActionPointHandler({ actionPoints, actionInfo }) {
	return (
		<>
			<ActionPointsBrowser actionPoints={actionPoints} />
			<ActionListMobile actionPoints={actionPoints} actionInfo={actionInfo} />
		</>
	);
}
